<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="eye icon"></i>
      {{ $t("course record preview") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/course_record_1.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div></div>
        <div id="print_element">
          <div class="prev_comp" ref="prev_comp"></div>
        </div>
        <!-- <pre>{{ data }}</pre> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button" @click="print">
        <i class="print icon"></i>
        {{ $t("print") }}
      </div>
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import { cloneDeep } from "lodash";
import Vue from "vue";
import PHE from "print-html-element";
// import RecordView from "./RecordView";

export default {
  name: "CourseRecordReprintModalIndex",
  components: {
    /* RecordView */
  },
  props: {},
  computed: {},
  data() {
    return {
      form: undefined,
      section: {},
      template: { css: "", js: "", html: "" },
      data: {},
      vueObject: undefined,
      threshold_score: 0,
      recovery_threshold: undefined,
    };
  },
  methods: {
    show_modal(record) {
      let vm = this;

      /**
       * get template
       */
      if (record) {
        /** Get section info */
        local_api(vm, "post", "/course/record/do-get", {
          u: record.uuid,
        })
          .then((r) => {
            vm.data = r;
            // vm.$refs.record_view.init(r);

            // let trgt = window.jQuery("#print_element div");
            // console.log(trgt);
            // trgt.html("");

            //   .html("<div ></div>");

            setTimeout(() => {
              let mixin = {};
              try {
                // eslint-disable-next-line no-unused-vars
                let stages = r.stages;
                // eslint-disable-next-line no-unused-vars
                let student_list = r.detail;
                // eslint-disable-next-line no-unused-vars
                let branch_name = r.std_branch.name;
                // eslint-disable-next-line no-unused-vars
                let course_name = r.crs_course.name;
                // eslint-disable-next-line no-unused-vars
                let career_name = r.std_career.name;
                // eslint-disable-next-line no-unused-vars
                let professor_name = r.pfs_professor.setup.name;
                // eslint-disable-next-line no-unused-vars
                let college_number = r.pfs_professor.setup.college_number;
                // eslint-disable-next-line no-unused-vars
                let studying_time_name = r.std_studying_time.name;
                if (vm.template.js) {
                  //   let js = vm.template.js.replace(
                  //     "${student_list}",
                  //     `'${student_list}'`,
                  //   );
                  eval(`mixin = ${vm.template.js}`);
                }

                // let dvs = window.jQuery("#print_element div");
                // let trgtElement = undefined;
                // if (dvs && dvs.length > 0) {
                //   trgtElement = dvs[0];
                // }
                // console.log("trgtElement: ", trgtElement);

                vm.vueObject = new Vue({
                  template: vm.template.html,
                  mixins: [mixin],
                  el: ".prev_comp",
                  data: () => {
                    return {};
                  },
                  methods: {},
                  mounted: function() {
                    let _vm = this;
                    _vm.stages = r.stages;

                    if (["final"].includes(vm.data.record_type)) {
                      _vm.student_list = r.detail;
                    } else if (
                      ["recovery_1", "recovery_2"].includes(vm.data.record_type)
                    ) {
                      if (vm.recovery_threshold && vm.threshold_score) {
                        _vm.student_list = r.detail.filter((st) => {
                          return st.total < vm.threshold_score;
                        });
                      } else {
                        _vm.student_list = r.detail;
                      }
                    }

                    if (vm.template.css) {
                      setTimeout(() => {
                        window
                          .jQuery(_vm.$el)
                          .append(`<style>${vm.template.css}</style>`);

                        // vm.trigger_print(group, weighting, section.uuid, stdnts);
                      }, 200);
                    } else {
                      // vm.trigger_print(group, weighting, section.uuid, stdnts);
                    }

                    window.jQuery("#print_element div").addClass("prev_comp");
                  },
                });
              } catch (ex) {
                console.error(ex);
              }
            }, 500);
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
          onHide() {
            console.log("destroying vue instance");
            // window.jQuery(vm.vueObject.$el).empty();
            vm.vueObject.$destroy();
            // window.jQuery("#print_element div").empty();
          },
        })
        .modal("show");
    },
    print() {
      let trgt = document.getElementById("print_element");
      PHE.printElement(trgt);
    },
    getScore(student_id, stage_uuid) {
      let vm = this;
      let trgtStudentScore = vm.section.crs_scores.find((sc) => {
        return sc.student_id == student_id;
      });
      if (trgtStudentScore) {
        // return JSON.stringify(trgtStudentScore, null, 2);
        // console.log(trgtStudentScore);
        /** Get stage activities */
        let trgtActivities = trgtStudentScore.setup.filter((ph) => {
          return ph.phase_uuid == stage_uuid;
        });
        if (trgtActivities) {
          let total = trgtActivities.reduce((prev, curr) => {
            return (
              prev +
              (isNaN(curr.score)
                ? 0
                : Number(curr.score) * Number(curr.weighting_percent)) /
                100
            );
          }, 0);
          return total;
        } else return "";
      } else {
        return "";
      }
      // console.log(student_id, stage_uuid);
    },
    getTotal(student_id) {
      let vm = this;
      let trgtStudentScore = vm.section.crs_scores.find((sc) => {
        return sc.student_id == student_id;
      });
      if (trgtStudentScore) {
        // return JSON.stringify(trgtStudentScore, null, 2);
        // console.log(trgtStudentScore);
        /** Get stage activities */
        let weightings = cloneDeep(vm.section.setup.weighting);
        weightings.map((w) => {
          let activities = trgtStudentScore.setup.filter((itm) => {
            // console.log(itm, w);
            return itm.phase_uuid == w.uuid;
          });
          w.activities = activities;
          w.total = activities.reduce((prev, curr) => {
            return (
              prev +
              (isNaN(curr.score)
                ? 0
                : Number(curr.score) * Number(curr.weighting_percent)) /
                100
            );
          }, 0);
        });

        let ttl = weightings.reduce((prev, curr) => {
          return (
            prev +
            (Number(curr.total || 0) * Number(curr.weighting_percent)) / 100
          );
        }, 0);

        return ttl;
      } else {
        return "";
      }
      // console.log(student_id, stage_uuid);
    },
    get_configuration() {
      let vm = this;
      local_api(vm, "post", "/course/record/do-get-configuration")
        .then((r) => {
          if (r) {
            // vm.$refs.record_view.setTemplate(r.template);
            vm.template = r.template;
            if (r.threshold_score)
              vm.threshold_score = Number(r.threshold_score);
            if (r.recovery_threshold)
              vm.recovery_threshold = r.recovery_threshold;
            /**
             * Set stored configuration
             */
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {},
  created() {
    this.get_configuration();
  },
  watch: {},
  updated: function() {},
};
</script>
